module.exports = __webpack_public_path__ + "static/img05-2f71d049c1087aa91c2625a9656c3c83.jpg";